import {
  type AgentReportColumn,
  type AgentReportMetrics,
  missingAgentMetricPeriods,
} from 'constants/agentReporting';
import React from 'react';
import { Link } from 'react-router-dom';
import { formatDuration, formatTokens } from 'routes/agentTracking/agentTracking.model';

export function formatAgentReportValue(
  metrics: AgentReportMetrics | undefined,
  column: AgentReportColumn
) {
  const value = metrics?.[column];
  if (value == null) return '—';
  const formatted =
    column === 'agent_time'
      ? formatDuration(value)
      : column === 'agent_cost'
        ? `$${value.toFixed(2)}`
        : column.includes('tokens')
          ? formatTokens(value)
          : String(value);
  const partial = missingAgentMetricPeriods(metrics, column);
  return `${formatted}${partial ? ' · partial' : ''}`;
}
export function AgentReportValue({
  metrics,
  column,
  link = true,
}: {
  metrics?: AgentReportMetrics;
  column: AgentReportColumn;
  link?: boolean;
}) {
  const value = formatAgentReportValue(metrics, column);
  const title =
    column === 'agent_cost'
      ? `Standard API-price estimate in USD, pricing ${metrics?.pricing_version || 'unavailable'}. Not provider billing. Missing costs are excluded.`
      : column === 'agent_tokens'
        ? 'Total tokens: uncached input, output, cache reads and cache writes. Missing measurements are excluded.'
        : 'Recorded agent activity. Missing measurements are excluded; agent time may overlap human time.';
  return link && metrics?.filters && Number(metrics.agent_periods) > 0 ? (
    <Link title={title} to={`/superreports/agents?${new URLSearchParams(metrics.filters)}`}>
      {value}
    </Link>
  ) : (
    <span title={title}>{value}</span>
  );
}
